import { type FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TextSmall } from '@/components/Typography/Typography';
import { Accordion } from '@/components/ui/Accordion/Accordion';

import { faqList } from './config';

const LotteryAnswers: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col gap-2 mt-8">
      {faqList.map(({ question, answer }, index) => (
        <Accordion
          key={`question-${index}`}
          className="border-b border-white/20 pb-2"
          classNames={{ chevron: 'ml-6' }}
          variant="default"
          head={() => (
            <div className="w-full min-h-[40px] py-2 flex items-center max-w-[87.87%]">
              <span className="text-[18px] font-bold leading-1.3">
                {t(question)}
              </span>
            </div>
          )}
        >
          <div className="w-full pr-8 pb-4">
            {typeof answer === 'string' ? (
              <TextSmall className="text-white/80 !leading-[140%]">
                <Trans i18nKey={answer} components={{ 1: <br /> }} />
              </TextSmall>
            ) : (
              <ol className="pl-[20px] !list-decimal !text-[0.875rem] text-white/80 !leading-[140%]">
                {answer.map((string, index) => (
                  <li
                    key={`answer-${index}`}
                    className="!list-decimal pl-[2px]"
                  >
                    <TextSmall className="text-white/80 !leading-[140%]">
                      <Trans i18nKey={string} components={{ 1: <br /> }} />
                    </TextSmall>
                  </li>
                ))}
              </ol>
            )}
          </div>
        </Accordion>
      ))}
    </div>
  );
};

export { LotteryAnswers };
